var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.92 494.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec8365;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,35.53c10.21,15.76,28.2,25.56,39.72,41.24,15.27,20.78,27.92,44.91,33.32,70.22,8.8,41.22,9.56,87.3,35.46,123.08,41.27,57.03,113.55,60.05,167.37,95.92,54.18,36.11,57.71,124.52,133.86,128.35,77.71,3.91,130.73-92.89,141.32-159.27,7.88-49.44.46-85.55-33.54-120.94-41.3-42.98-85.79-77.13-138.78-105.04C298.24,66.7,208.78,26.43,119.7,6.04,95.75.55,6.99-13.18,0,35.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble1);
export default __webpack_public_path__ + "static/media/bubble1.587c5f77e3d47aa598505a1de09f6591.svg";
export { ForwardRef as ReactComponent };